import React from 'react';
import cn from 'classnames';
import {StandardProps} from '..';

export type ButtonBaseProps = StandardProps<React.ButtonHTMLAttributes<HTMLButtonElement>>;

export const ButtonBase = React.forwardRef<HTMLButtonElement, ButtonBaseProps>(
  ({className, children, type, ...restProps}, ref) => {
    return (
      <button ref={ref} type={type || 'button'} className={cn('button-base', className)} {...restProps}>
        {children}
      </button>
    );
  },
);

ButtonBase.displayName = 'ButtonBase';

export default ButtonBase;
